import { useState } from 'react'
import { InputContainer } from 'components/ideal-core-ui'
import { AddButton } from 'components/common/AddButton'
import s from './AddTeam.scss'
import { useLoading } from 'hooks'
import { makePostRequest } from 'utils/api'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import { useDispatch } from 'react-redux'

const AddTeam = ({ setTeams, teams }) => {
  const [teamName, setTeamName] = useState('')
  const [teamAbbreviation, setTeamAbbreviation] = useState('')
  const [, withLoadingLocks] = useLoading()
  const reduxDispatch = useDispatch()

  const createTeam = async () => {
    try {
      const team = await withLoadingLocks(
        makePostRequest('/v1/teams', {
          name: teamName,
          abbreviation: teamAbbreviation
        })
      )
      setTeams([...teams, team])
      setTeamName('')
      setTeamAbbreviation('')
      reduxDispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'Team created successfuly',
          level: 'success'
        }
      })
    } catch (e) {
      reduxDispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'There was a problem creating team',
          level: 'error'
        }
      })
    }
  }

  return (
    <>
      <h5 className={s.teamsWrapper}>Teams</h5>
      <p>
        To create a new team, enter a name and a 3-letter abbreviation. The abbreviated name will
        show on the calendar next to each opportunity.
      </p>
      <div className={s.itemWrapper}>
        <InputContainer
          type="text"
          cb={value => setTeamName(value)}
          text={teamName}
          placeholder="Enter Team Name"
          classname={s.addItemInput}
        />
        <InputContainer
          type="text"
          cb={value => setTeamAbbreviation(value)}
          text={teamAbbreviation}
          placeholder="3-letter name (TM1)"
          classname={s.addItemInput}
          maxLength="3"
        />
        <AddButton
          disabled={!teamName || !teamAbbreviation}
          className={s.createTeamBtn}
          onClick={createTeam}
        >
          Create Team
        </AddButton>
      </div>
    </>
  )
}

export default AddTeam
